<input [id]="inputId" type="file" [accept]="accept" />

<div *ngIf="previewUrl || file" class="file-preview">
  <ng-container *ngIf="previewUrl && contentType === 'video'; else imgPreview">
    <video *ngIf="previewUrl; else fileName">
      <source [src]="previewUrl" type="video/mp4" />
    </video>
  </ng-container>
  <ng-template #imgPreview>
    <img *ngIf="previewUrl; else fileName" [src]="previewUrl" alt="Preview" />
  </ng-template>
  <ng-template #fileName>
    <div *ngIf="!previewUrl && file" class="file-name">{{ file.name }}</div>
  </ng-template>
</div>
<div class="file-select">
  <label [for]="inputId">{{ 'formFilUpload.browseForFile' | translate }}</label>
</div>

<ng-content></ng-content>
